import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'join-by-visit-code-req',
  ['INIT'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: ['virtual_visits', 'join_by_visit_code'],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/join-by-visit-code-req.js